<div data-testid="file-upload-file-uploader-block" class="file-uploader-block">
  <dx-file-uploader data-testid="file-upload-file-uploader"
             [selectButtonText]="selectButtonText"
             [labelText]="labelText"
             [uploadFile]="onFileUpload"
             [accept]="accept"
             [uploadMode]="fileUploadMode"
             [inputAttr]="{ 'aria-label': 'Select Files' }"
             [multiple]="multiple"
             [(value)] = "files"
             [(allowCanceling)]="allowCancelling"  
             [disabled]="!isEditable"   
             [showFileList]="false" 
         >
  </dx-file-uploader>
<div *ngFor="let file of files">

  <div data-testid="file-upload-file-uploader-item" class="file-uploader-item">
    <div data-testid="file-upload-file-uploader-text" class="file-uploader-text">
      <span>{{ file.name }}</span>
    </div>
    <div data-testid="file-upload-file-uploader-icon" class="file-uploader-icon" (click)="removeFile(file)">
       <i class="dx-icon dx-icon-close"></i>
    </div>
  </div>
</div>

